import { MdLocationOn } from 'react-icons/md'
import classNames from 'classnames'
import type { CommonProps } from '@/@types/common'

export const LocationInfo = (props: CommonProps) => {
    const { className } = props

    return (
        <div className={classNames('flex items-center', className)}>
            <div className="w-[60] h-[60] flex justify-center items-center">
                <MdLocationOn className="text-xl text-error" size={30} />
            </div>

            <div className="text-xs text-gray-700 dark:text-gray-200 flex flex-col">
                <span>
                    <strong>г. Москва</strong>
                    <br />
                     ул. Краснодонская д.2. к.1
                </span>
                <span>м. Волжская</span>
            </div>
        </div>
    )
}
